import FJConfig from '../config/FJConfig';
import $ from 'jquery';

const getQueryString = name => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r && r.length >= 3) return unescape(r[2]);
    return null;
};

const ajaxPoster = function (options) {
    let { url, data, success, error, complete } = options;
    if (!data) data = {};
    // if (window.csrf_token) data[window.csrf_token] = 1;
    try {
        let r = $.ajax(url, {
            type: 'POST',
            data: data,
            timeout: 15000, //超时时间：15秒 单位毫秒
            success: success ? success : () => {},
            error: error ? error : () => {},
            complete: complete ? complete : () => {},
        });
        return r;
    } catch (e) {
        if (error) {
            error();
        }
    }
};
let postOptions = {
    method: 'POST', // post请求
    // mode:'cors',
    // headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    // },
};
const fetchPost = (url, data) => {
    let URL = FJConfig.requestPath + url;
    console.log({ body: data });
    return fetch(URL, {
        ...postOptions,
        body: JSON.stringify({ ...data }),
    });
};

// 登录成功后获取需要动态加载的js地址，目前用于移动端订阅页js
const getLazyLoadJsUrl = async name => {
    const url = FJConfig.serverPath + `/load-js?name=${name}`;
    const res = await fetch(url);
    const data = await res.json();
    if (data.code === 200) {
        return data.data;
    }
    return null;
};

export default {
    // 检查账号是否存在
    checkAccountExist(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/verify-email',
                data,
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
    // 账号登录
    emailLogin(data) {
        return new Promise((resolve, reject) => {
            let code = getQueryString('code');
            let referrer = getQueryString('referrer');
            let body = { ...data };
            if (code) body.code = code;
            if (referrer) body.referrer = referrer;
            if (window.csrf_token) {
                body[window.csrf_token] = 1;
            }
            ajaxPoster({
                url: FJConfig.requestPath + '/user/login',
                data: body,
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
    // 账号注册
    emailRegister(data) {
        return new Promise((resolve, reject) => {
            let code = getQueryString('code');
            let referrer = getQueryString('referrer');
            let body = { ...data };
            if (code) body.code = code;
            if (referrer) body.referrer = referrer;
            if (window.csrf_token) {
                body[window.csrf_token] = 1;
            }
            ajaxPoster({
                url: FJConfig.requestPath + '/user/signup',
                data: body,
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
    // 验证码发送
    sendEmail(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/send-verification-code',
                data,
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },

    // 验证验证码
    confirmCode(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/verify-code',
                data,
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },

    // 重设密码
    resetPassword(data) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/change-password',
                data: {
                    email: data.email,
                    code: data.code,
                    pswd2: data.newPassword,
                    pswd3: data.confirmPassword,
                },
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
    // 获取城市code
    getUserCountryCode(data) {
        return new Promise((resolve, reject) => {
            resolve('');
        });
    },
    // 发送谷歌验证成功后的 accessToken
    sendGoogleToken(accessToken, loc) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/connectGoogleUser',
                data: {
                    token: accessToken,
                    loc,
                },
                success: data => {
                    // let localCountryCode = data.split('\n')[9].match(/=(.*)/)[1];
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },
    // 发送facebook验证成功后的 accessToken
    sendFacebookToken(accessToken, loc) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/connectFacebookUser',
                data: {
                    token: accessToken,
                    loc,
                },
                success: data => {
                    // let localCountryCode = data.split('\n')[9].match(/=(.*)/)[1];
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },

    /**
     * @description 重置账号
     * @returns {Promise<unknown>}
     */
    restoreAccount(email) {
        return new Promise((resolve, reject) => {
            ajaxPoster({
                url: FJConfig.requestPath + '/user/restore-user',
                data: {
                    email: email,
                },
                success: data => {
                    resolve(data);
                },
                error: e => {
                    reject(e);
                },
            });
        });
    },

    getLazyLoadJsUrl,
};
